import { Competition, Product, QuoteUploadFormData, RepQuoteFormState } from 'shared/types/quotes';

export const specifiedMfgOptions = [
  'ACCESSIBILTY PROFESSIONAL',
  'ACRYLINE',
  'AMERICAN STANDARD',
  'AQUA BATH',
  'AQUA GLASS',
  'AQUARIUS',
  'AQUATIC',
  'BATHCRAFT',
  'BEST BATH',
  'BOOTZ',
  'CLARION',
  'COMFORT DESIGN',
  'CRANE FIAT',
  'CUSTOM',
  'DIAMOND',
  'DREAMLINE',
  'EVERFAB',
  'FIBERCARE',
  'FIBERFAB',
  'FLORESTONE',
  'HAMILTON',
  'INPRO',
  'KOHLER',
  'MAAX AKER',
  'MINCEY MARBLE',
  'MUSTEE',
  'NO SPECS',
  'OASIS',
  'PRAXIS',
  'PROFLO',
  'SALO',
  'SPURLIN',
  'STERLING',
  'SWAN',
  'TILE',
  'UNIVERSAL RUNDLE',
  'WARM RAIN',
  'WATERMARK',
  'WILLOUGHBY',
] as const;
export type SpecifiedOption = typeof specifiedMfgOptions[number];

export const yesNoOptions = [
  { text: 'Yes', value: true },
  { text: 'No', value: false },
] as const;
export type YesOrNo = typeof yesNoOptions[number];

export const competitionInfoSourceOptions = [
  'CUSTOMER PROVIDED QUOTE',
  'INDUSTRY KNOWLEDGE',
  'ONLINE RESEARCH',
  'OTHER',
] as const;
export type CompetitionInfoSource = typeof competitionInfoSourceOptions[number];

export const quoteStatusOptions = [
  'DRAFT',
  'SUBMITTED & RECEIVED',
  'IN PROCESS',
  'INCOMPLETE INFORMATION',
  'REVIEWED',
  'APPROVED',
  'CLOSED - WON',
  'CLOSED - LOST',
  'REVISION REQUESTED',
  'NO QUOTE',
] as const;
export type QuoteStatusOption = typeof quoteStatusOptions[number];

export const ERPOptions = ['AS400', 'CMS', 'Dreamline/Conga', 'SALO', 'SAP'] as const;
export type ERPOption = typeof ERPOptions[number];

export const defaultQuoteState: RepQuoteFormState = {
  id: '',
  wholesaler: '',
  wholesalerCustomerNumber: '',
  wholesalerCity: '',
  wholesalerState: '',
  wholesalerContact: '',
  wholesalerEmail: '',
  wholesalerPhone: '',
  plumberContractor: '',
  plumberProjectType: '',
  plumberArchitect: '',
  plumberEngineer: '',
  plumberSpecifiedMfg: '',
  plumberOutOfTerritory: false,
  jobInfoProjectName: '',
  jobInfoCity: '',
  jobInfoState: '',
  jobInfoStateName: '',
  jobInfoFullTruckload: false,
  jobInfoEstimatedSchedule: '',
  jobInfoReleaseAndFirstOrderDate: '',
  jobInfoJobDuration: '',
  competitionInfoSourceOfInfo: '',
  competitionInfoOtherSourceOfInfo: '',
  competitionInfoCompetition: [],
  products: [],
  quoteDocumentation: [],
  files: undefined,
  notes: '',
  optionsETOS: '',
  requestedBy: '',
  repAgency: '',
  lastModifiedBy: '',
  director: '',
  dateSubmitted: '',
  dateRevised: '',
  dateApproved: '',
  dateDeleted: '',
  status: '',
  brand: '',
  quoteFilesToDelete: [],
};

export const defaultCompetition: Competition = {
  currentMarketPrice: 0,
  modelName: '',
  modelNumber: '',
};

export const defaultProduct: Product = {
  totalQty: 0,
  minOrderQty: 0,
  brand: '',
  modelName: '',
  tag: '',
  modelNumber: '',
  requestedPrice: 0,
  color: '',
  options: '',
  createdDate: new Date().toISOString(),
};

export const defaultQuoteUpload: QuoteUploadFormData = {
  documentType: 'ADDITIONAL DOCUMENTATION',
  files: undefined,
};

export const defaultFeedback = {
  feedback: '',
};

export const feedbackEmail = 'ABGQuoteToolSupport@clients.insight2profit.com';
